import posthog from "posthog-js";
import { useEffect, useMemo } from "react";
import { ProfileFragment } from "../graphql/profile/profile.fragment";
import { useProfileQuery } from "../graphql/profile/profile.query";
import { useAppSelector } from "../store";

interface Profile {
  profile?: ProfileFragment;
  loading: boolean;
}

export const useProfile = (): Profile => {
  const authenticated = useAppSelector((state) => state.auth.authenticated);
  const email = useAppSelector((state) => state.auth.email);

  const { loading, data } = useProfileQuery({
    skip: !authenticated,
  });

  useEffect(() => {
    if (!data) return;

    posthog.identify(data.user.id, {
      email: data.user.email,
      first_name: data.user.firstName,
      last_name: data.user.lastName,
    });
  }, [data]);

  const profile = useMemo(() => {
    if (data?.user) {
      return data.user;
    }

    return {
      email,
    } as ProfileFragment;
  }, [data]);

  return {
    loading,
    profile: profile as ProfileFragment,
  };
};
